import React from 'react';

const Textarea = (props) => {
    const {
        name        = '',
        value       = '',
        type        = 'text',
        onChange    = (value) => {},
        disabled    = false
    } = props;

    return (
        <textarea
            style={{minHeight: '30px'}}
            onChange={(event) => onChange(event.target.value)}
            disabled={disabled}
            name={name}
            id={name}
            className={'input-field'}
            autoComplete="off"
        >{value}</textarea>
    );
}

export default Textarea;
